import "./App.css";
import { useEffect, useState, useContext } from "react";
import {
  Box,
  Typography,
  Grid,
  Chip,
  IconButton,
  Button,
  Divider,
  Toolbar,
  Snackbar,
  Alert,
  CssBaseline,
  Container,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import APIS from "./singaporeData.json";
import Navbar from "./Components/Appbar";
import Sidebar from "./Components/Sidebar";
import { Route, Routes, useLocation } from "react-router-dom";
import IntroductionPage from "./Pages/Introduction";
import ErrorCodesPage from "./Pages/ErrorCodes";
import ApiDetailPage from "./Pages/ApiDetails";
import { BrowserRouter } from "react-router-dom";
import { RegionProvider } from "./RegionContext";
import copy from "copy-to-clipboard";

function App() {
  const [open, setOpen] = useState(false);

  const copyClipBoard = (content) => {
    let value = typeof content === "object" ? JSON.stringify(content) : content;

    copy(value);
    setOpen(true);
  };

  return (
    <RegionProvider>
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity="success" variant="filled" sx={{ width: "100%" }}>
          Copied
        </Alert>
      </Snackbar>

      <BrowserRouter basename="/GlobalPartnerAPI">
        <Box>
          <CssBaseline />
          <Navbar />

          <Container maxWidth="xl">
            <Box className="api-main-layout">
              <Sidebar />
              <Box className="api-page-layout" component="main">
                {/* {children} */}

                <Routes>
                  <Route
                    path="/"
                    element={<IntroductionPage copyClipBoard={copyClipBoard} />}
                  />
                  <Route
                    path="/:api"
                    element={<ApiDetailPage copyClipBoard={copyClipBoard} />}
                  />
                  <Route path="/ErrorCodes" element={<ErrorCodesPage />} />
                </Routes>
              </Box>
            </Box>
          </Container>
        </Box>
      </BrowserRouter>
    </RegionProvider>
  );
}

export default App;
